<template>
	<div class="home-background">
		<!-- <div style="width: 100%; height: 100%; position: absolute; color:#ddd; background-color: #FAFAFA; z-index: 1; left:0; top: 0; display: flex; justify-content: center; align-items: center; font-size: 50px; font-weight: bold;">
			준비 중
		</div> -->
		<div class="home-title">
			<div class="title-left">
				<img style="width: 19px; height: 21px;" src="@/assets/images/login/coodi_icon.png" />
				<span>코디네이터 목록</span>
			</div>
		</div>
		<div class="search-content">
			<select class="list-select" v-model="searchCategory">
				<option value="">선택</option>
				<option value="아이디">아이디</option>
				<option value="이름">이름</option>
				<!-- <option value="데이터분류">데이터분류</option>
				<option value="상태">상태</option> -->
			</select>
			<input
				type="text"
				class="input-crud"
				style="width: 240px;"
				v-model="searchText"
				@keyup="keyupHandler"
			/>
			<div class="search-btn" @click.stop="selectCoordiList()">
				<img src="@/assets/images/home/search.png"/>
				검색
			</div>
		</div>
		<div class="home-bottom" style="height: calc(100% - 165px);">
			<div class="content-box">
				<table class="tb-list-vertical" style="table-layout: fixed;">
					<colgroup>
						<!-- <col width="12%">
						<col width="16%">
						<col width="16%">
						<col width="20%">
						<col width="18%">
						<col width="18%"> -->
					</colgroup>
					<thead>
						<th>코디네이터 아이디</th>
						<th>이름</th>
						<th>전화번호</th>
						<th>이메일</th>
						<th>가입 일시</th>
					</thead>
					<tbody>
						<template 
							v-for="(user, index) in userList"
						>
							<tr :key="index" @click.stop="doOpenData(user)">
								<td>{{user.userId}}</td>
								<td>{{user.userName}}</td>
								<td>{{user.mobileTelno}}</td>
								<td>{{user.emailAddress}}</td>
								<td>{{user.firstRegistDate.substring(0, 11)}}</td>
							</tr>
						</template>
						<tr v-if="userList.length == 0">
							<td colspan="5" class="no-list">
								데이터가 존재하지 않습니다.
							</td>
						</tr>
					</tbody>
				</table>
				<div class="pagination-wrap">
					<pagination
						:data="pagination"
						:show-disabled="true"
						:limit="4"
						@pagination-change-page="doSearchPage"
					>
						<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
						<button type="button" slot="next-nav" class="page-next">&gt;</button>
					</pagination>
				</div>
			</div>
		</div>
		<CoordiPopup v-if="isDataPopup" :user="user"/>
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
import EventBus from "@/script/EventBus.js";
import CoordiPopup from "@/components/coordinator/CoordiPopup.vue";
import axios from "axios";
Vue.use(VeeValidator);

export default {
	name: "CoordiList",
	created() {
		this.logger.debug(this, ".created()");
		if(!sessionStorage.getItem('roleCd').indexOf('ROLE_MONITORING') == 0){
			if(!sessionStorage.getItem('roleCd').indexOf('ROLE_ADMIN') == 0){
				this.$router.push(Vue.prototype.config.contextRoot + '/home');
			}
		}
		console.log(this.userInfo.userId);
		this.selectCoordiList();
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
	},
	data() {
		return {
			items: {},
			isMode: 1,
			today: "",
			isDataPopup: false,
			user: {},
			userList: [],
			pagination: {},
			searchText: "",
			searchCategory: "",
		};
	},
	components: {
		CoordiPopup
	},
	watch: {
		searchText: function(val) {
			// this.item.pageName = val;
			this.items.searchText = val;
			this.items.pageNum = 1;
		},
		searchCategory: function(val) {
			// this.item.pageName = val;
			this.items.searchCategory = val;
			this.items.pageNum = 1;
		}
	},
	methods: {
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		selectCoordiList(){
			EventBus.$emit("project-loading", true);
			this.logger.debug(this, "selectCoordiList()");
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/user/selectCoordiList.do", this.items)
				.then((response) => {
					console.log(response);
					this.userList = response.data.userList;
					this.pagination = response.data.pagination;

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			// this.searchTextVal = event.target.value;
			if (event.keyCode == 13)
			{
				EventBus.$emit("project-loading", true);
				this.selectCoordiList();
			}
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.items.pageNum = page;
			this.selectCoordiList();
		},
		getDateValue() {
			var informedConsentDtTemp = this.items.informedConsentDtTemp;
			var informedConsentDt = this.items.informedConsentDt;

			if(this.utils.isEmpty(informedConsentDtTemp))
			{
				if(this.utils.isEmpty(informedConsentDt))
				{
					return "YYYY-MM-DD"
				}
				else
				{
					return informedConsentDt;
				}
			}
			else
			{
				{
					this.$set(this.items, "informedConsentDt", informedConsentDtTemp);
				}
				return this.items.informedConsentDt;
			}
		},
		clearDate() {
			this.$set(this.items, "informedConsentDt", "");
			this.$set(this.items, "informedConsentDtTemp", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		doOpenData(user) {
			this.logger.debug(this, "doOpenData()");
			this.isDataPopup = true;
			this.user = user;
		},
		changeTap(type){
			this.isTab = type;
		}
	},
};
</script>
<style>
@import '../../assets/css/login/login.css';
.home-background{
	width: 100%;
	height: 100%;
}
.home-title{
	width: 100%;
	height: 29px;
	display: flex;
    justify-content: space-between;
}
.title-left{
	display: flex;
    align-items: center;
    column-gap: 12px;
	font-size: 24px;
	font-weight: bold;
}
.title-right{
	display: flex;
    align-items: center;
	font-size: 14px;
	column-gap: 20px;
}
.warn-dot{
	width: 16px;
	height: 16px;
	border-radius: 50px;
}
.font-red{
	color: #F94848;
}
.red{
	background-color: #F94848;
}
.yellow{
	background-color: #FFAD09;
}
.warn-wrap{
	display: flex;
	align-items: center;
    column-gap: 4px;
}
.home-top{
	width: 100%;
	height: 180px;
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.home-bottom{
	width: 100%;
	height: calc(100% - 269px);
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.content-box{
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 0 10px 0px #ccc;
	background-color: #fff;
	position: relative;
}
.top-sub-title-red{
	width: 100%;
	height: 52px;
	background-color: #F94848;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.top-sub-title-green{
	width: 100%;
	height: 52px;
	background-color: #4BD985;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.count-dot{
	width: 8px;
	height: 8px;
	border: 1px solid #fff;
	border-radius: 50px;
}
.top-count{
	display: flex;
    column-gap: 5px;
	margin-right: 32px;
}
.white{
	background-color: #fff;
}
.none-content{
	width: 100%;
    height: calc(100% - 52px);
    display: flex;
    justify-content: center;
    align-items: center;
	font-size: 18px;
	color: #A9A9A9;
}
.left-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/left_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.right-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/right_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.name-tag{
	width: 44px;
	height: 22px;
	background-color: #EFEFEF;
	border-radius: 11px;
	font-size: 14px;
	color: #A9A9A9;
	display: flex;
    justify-content: center;
    align-items: center;
}
.data-zone{
	display: flex;
    justify-content: flex-start;
	align-items: center;
	column-gap: 10px;
	font-size: 16px;
	font-weight: bold;
}
.dot-line{
	height: 64px;
	border: 1px solid #DDDDDD;
	border-style: dashed;
}
.top-data{
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
}
.table-name{
	font-size: 20px;
	font-weight: bold;
	width: 100%;
	height: 60px;
	display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 10px;
    padding-left: 32px;
}
.table-btn{
	width: 66px;
	height: 29px;
	border-radius: 15px;
	font-size: 16px;
	font-weight: 600;
	color: #6D6D6D;
}
.table-btn:hover{
	color: #FFF;
	background-color: #555555;
}
.btn-on{
	color: #FFF;
	background-color: #555555;
}
.list-select{
	width: 240px;
	height: 40px;
    padding: 0 15px;
    border: 1px solid #A9A9A9;
	border-radius: 5px;
    font-size: 10pt;
    color: #090909;
	
}
.search-content{
	display: flex;
    align-items: center;
	column-gap: 10px;
	margin: 25px 0;
	padding-bottom: 25px;
    border-bottom: 1px solid #BDC1C6;
}
.search-btn{
	min-width: 100px;
	height: 40px;
	border-radius: 5px;
	background-color: #555555;
	color: #fff;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.search-btn:hover{
	background-color: #0176F9;
}
.search-btn > img{
	width: 13.5px;
	height: 14.5px;
}
.status{
	min-width: 55px;
	width: 55px;
	height: 22px;
	border-radius: 12px;
	color: #fff;
	font-size: 14px;
	display: flex;
	justify-content: center;
    align-items: center;
}
.care-btn-zone{
	width: 230px;
	height: 40px;
	padding: 5px;
	background-color: #fff;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 0 5px;
	column-gap: 5px;
}
.care-btn{
	height: 32px;
	border-radius: 6px;
	display: flex;
    justify-content: center;
    align-items: center;
	flex: 1;
	color: #090909;
	font-size: 16px;
	font-weight: bold;
	cursor: pointer;
}
.care-btn:hover{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
.care-on{
	background-color: #1A7AFF;
	color: #fff;
	box-shadow: 1px 1px 8px 0px rgb(0, 23, 85, 0.2);
}
</style>
